module.exports = __webpack_public_path__ + "static/img/tracey_svg.3938405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tracey_svg.png
// module id = 0VSI
// module chunks = 1